import React from 'react';

export const MagnifyingGlass = (props: any) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
    <path
      fillRule="evenodd"
      d="M.13 9.024c0 4.912 3.981 8.894 8.894 8.894 2.1 0 4.03-.728 5.551-1.946l5.609 5.61c.385.385 1.011.385 1.397 0 .363-.364.385-.94.064-1.328l-.064-.07-5.609-5.609c1.218-1.521 1.946-3.451 1.946-5.551 0-4.913-3.982-8.895-8.894-8.895C4.11.13.129 4.111.129 9.024zm1.976 0c0-3.821 3.097-6.918 6.918-6.918 3.82 0 6.917 3.097 6.917 6.918 0 1.903-.769 3.627-2.013 4.878l-.014.012-.01.013c-1.252 1.245-2.976 2.014-4.88 2.014-3.821 0-6.918-3.097-6.918-6.917z"
    />
  </svg>
);
